<template>
  <div class="store">
    <div class="store_back" v-if="ispc">
      <div class="store_box store_box1">
      <h1>Get Your Own Well-decorated Dropshipping Store TODAY!</h1>
      <em></em>
      <p>Well-decorated dropshipping store save you a lot of time having a personal assistant to handle everything, you don't need experience or special skills, you get our lifetime support and help you find niches in high demand</p>
      <div class="store_box_button" @click="scroll">CHOOSE YOUR STORE</div>
      </div>
    </div>
    <div class="top" v-else >
    <div class="top_box">
      <div class="top_left">
        <div class="top_left_symbol title_icon"></div>
        <h2 class="top_left_title">Get Your Own Well-decorated</h2>
        <h2 class="top_left_title">Dropshipping Store TODAY!</h2>
        <div class="top_left_subtitle">Well-decorated dropshipping store save you a lot of time having a personal assistant to handle everything, you don't need experience or special skills, you get our lifetime support and help you find niches in high demand</div>   
        <div class="store_box_button" @click="scroll">CHOOSE YOUR STORE</div>
      </div>
    </div>
  </div>
    <div class="store_back2">
      <div class="store_box store_box2" >
      <h1>All you need for a successful start</h1>
      <div class="store_box2_content">
        <div class="store_box2_center" v-for='(item,index) in storedata' :key='index'>
          <img :src="item.img" :alt="item.name">
          <h2>{{item.name}}</h2>
          <div>{{item.content}}</div>
        </div>
      </div>
      </div>
    </div>
    <div class="store_back">
      <div class="store_box store_box2" >
      <h1>How it works</h1>
      <div class="store_overflow"><img src="/static/imgs/store4.svg" alt="line" class="store_works_line"></div>
      </div>
    </div>
    <div class="store_back3">
      <div class="store_box store_box2" >
      <h1>Choose the store that's best for you!</h1>
      <div class="store_box2_content  store_box2_content2">
        <div class="store_type" v-for='(item,index) in storedata3' :key='index' >
          <img :src="item.img" :alt="item.name" class="store_type_img">
          <h2>{{item.name}}</h2>
          <div class="store_type_view" @click="golink(item.link)">
            <img src="/static/imgs/store19.svg" alt="">
            <span>View the site</span>
          </div>
          <div class="store_type_button" @click="freshchat(1)">GET YOUR FOR ONLY $299</div>
        </div>
      </div>
      </div>
    </div>
    <div class="store_back">
      <div class="store_box store_box2" >
      <h1>Why buy a choose dropshipping store?</h1>
      <div class="store_box2_content">
        <div class="store_reason" v-for='(item,index) in storedata4' :key='index'>
          <h2>{{item.name}}</h2>
          <em></em>
          <div>{{item.content}}</div>
        </div>
      </div>
      </div>
    </div>
    <div class="store_back2">
      <div class="store_box store_box3" >
        <h1>Ready to start</h1>
        <h1>your own dropshipping business?</h1>
        <h2>Let us create a perfect store for you from scratch</h2>
        <div class="overflow">
        <table class="storetable">
          <thead>
            <tr>
              <th></th>
              <th>BASIC</th>
              <th>ADVANCED</th>
              <th>ULTIMATE</th>
            </tr>
          </thead>
          <tbody class="tablebody">
            <tr class="tablebody_first">
              <td>
                <p class="tablebody_first_p">PRICE:</p>
                <p>*One time payment</p>
              </td>
              <td >
                <div class="tablebody_first_td">
                  <p>$299</p>
                <div>
                  <label><input type="checkbox" @click="add($event,1)">Add hosting - $48/year
(Free SSL Included)</label>
                </div>
                </div>
              </td>
              <td >
                <div class="tablebody_first_td">
                  <p>$499</p>
                <div>
                  <label><input type="checkbox" @click="add($event,2)"><span>Add hosting - $48/year
(Free SSL Included)</span></label>
                </div>
                </div>
              </td>
              <td >
                <div class="tablebody_first_td">
                  <p>$899</p>
                <div>
                  <label><input type="checkbox" @click="add($event,3)">Add hosting - $48/year
(Free SSL Included)</label>
                </div>
                </div>
              </td>
            </tr>
            <tr class="tablebody_second">
              <td></td>
              <td><div @click="freshchat(1)" >GET MY STORE</div></td>
              <td><div @click="freshchat(2)">GET MY STORE</div></td>
              <td><div @click="freshchat(3)">GET MY STORE</div></td>
            </tr>
            <tr class="tablebody_head">
              <td><span class="tablebody_first_p">DEVELOPMENT</span></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-for="(item,index) in tabledata" :key="index" class="tablebody_content">
              <td>
                <div class="tablebody_content_first"> 
                  <span>{{item.name}}</span>
                  <div>
                    <img src="/static/imgs/store20.svg" alt="" @mouseover="bubble(index)" @mouseleave="bubbleout(index)">
                    <div class="bubble_box" v-if="index==showbubble">{{item.bubble}}
                      <div class="bubble_bottom"></div>
                    </div>
                  </div>
                </div>
              </td>
              <td><div class="tablebody_content_main"><img src="/static/imgs/store21.svg" alt="" v-if='index==1||index==2||index==0'><span v-else>{{item.content}}</span></div></td>
              <td><div class="tablebody_content_main"><img src="/static/imgs/store21.svg" alt="" v-if='index==1||index==2||index==0'><span v-else>{{item.content2}}</span></div></td>
              <td><div class="tablebody_content_main"><img src="/static/imgs/store21.svg" alt="" v-if='index==1||index==2||index==0'><span v-else>{{item.content3}}</span></div></td>
            </tr>
            <tr class="tablebody_head">
              <td><span class="tablebody_first_p">PROMOTION</span></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-for="(item,index) in tabledata2" :key="index + 'a'" :class="index==0?'tablebody_content2':index==1?'tablebody_content3':'tablebody_content'">
              <td>
                <div class="tablebody_content_first"> 
                  <span>{{item.name}}</span>
                  <div>
                    <img src="/static/imgs/store20.svg" alt="" @mouseover="bubble(index+6)" @mouseleave="bubbleout(index+6)">
                    <div class="bubble_box" v-if="(index+6)==showbubble">{{item.bubble}}
                      <div class="bubble_bottom"></div>
                    </div>
                  </div>
                </div>
              </td>
              <td><div class="tablebody_content_main">{{item.content}}</div></td>
              <td><div class="tablebody_content_main">{{item.content2}}</div></td>
              <td><div class="tablebody_content_main"><img src="/static/imgs/store21.svg" alt="" v-if='index==2'><span v-else>{{item.content3}}</span></div></td>
            </tr>
            <tr class="tablebody_head">
              <td><span class="tablebody_first_p">INCLUDED</span></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr v-for="(item,index) in tabledata3" :key="index + 'b'" :class="index==0?'tablebody_content':'tablebody_content2'">
              <td>
                <div class="tablebody_content_first"> 
                  <span>{{item.name}}</span>
                  <div>
                    <img src="/static/imgs/store20.svg" alt="" @mouseover="bubble(index+9)" @mouseleave="bubbleout(index+9)">
                    <div class="bubble_box" v-if="(index+9)==showbubble">{{item.bubble}}
                      <div class="bubble_bottom"></div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="tablebody_content_main">
                  <img src="/static/imgs/store21.svg" alt="" v-if='index==0'>
                  <div class="tablebody_content_main_center" v-else>
                    <p v-if="index==1">{{item.content}}</p>
                    <img src="/static/imgs/store21.svg" alt="" v-else>
                    <h3>ONE YEAR FREE</h3>
                    <div>{{item.content2}}</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="tablebody_content_main">
                  <img src="/static/imgs/store21.svg" alt="" v-if='index==0'>
                  <div class="tablebody_content_main_center" v-else>
                    <p v-if="index==1">{{item.content3}}</p>
                    <img src="/static/imgs/store21.svg" alt="" v-else>
                    <h3>ONE YEAR FREE</h3>
                    <div>{{item.content4}}</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="tablebody_content_main">
                  <img src="/static/imgs/store21.svg" alt="" v-if='index==0'>
                  <div class="tablebody_content_main_center" v-else>
                    <p v-if="index==1">{{item.content5}}</p>
                    <img src="/static/imgs/store21.svg" alt="" v-else>
                    <h3>ONE YEAR FREE</h3>
                    <div>{{item.content6}}</div>
                  </div>
                </div>
              </td>
            </tr>
             <tr class="tablebody_second tablebody_bottom">
              <td></td>
              <td><div @click="freshchat(1)">GET MY STORE</div></td>
              <td><div @click="freshchat(2)">GET MY STORE</div></td>
              <td><div @click="freshchat(3)">GET MY STORE</div></td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>
    <div class="store_back">
      <div class="store_box store_box4" >
        <h1>What else included?</h1>
        <h1>Just everything you need</h1>
        <div class="store_box2_content3">
          <div class="store_need" v-for='(item,index) in storedata5' :key='index'>
            <img :src="item.img" :alt="item.name">
            <div><span :class="index==10||index==4?'':'store_need_bold'">{{item.name}}</span><span class='store_need_bold'>{{item.name3}}</span><span :class="index==10?'store_need_bold':''">{{item.name2}}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="store_back2">
      <div class="store_box store_display" >
      <h1>Here's what our customers say:</h1>
      <DisPlay :sayList="sayList" name=".store_display" cater='1' count='3'></DisPlay>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from './common/footer.vue'
import DisPlay from './common/display.vue'
import TopCN from './common/topCN.vue'
export default {
  name:'storeshow',
  components:{
    Footer,
    DisPlay,
    TopCN
  },
  data(){
    return{
      storedata:[
        {
          name:'Perfect website',
          img:'/static/imgs/store1.svg',
          content:'When you choose a dropshipping store template, you benefit from its cutting-edge software and professional design that’s optimized for maximum profits. All for quite an affordable price!'
        },
        {
          name:'Hot products',
          img:'/static/imgs/store2.svg',
          content:'No more figuring out what to dropship: Our dropshipping stores are packed with proven bestsellers in high-demand niches. Just sell it with your eyes closed.'
        },
        {
          name:'Built-in solutions',
          img:'/static/imgs/store3.svg',
          content:'ANTDIY provide you with a one-stop AliExpress dropshipping solution. ANTOOLS is an integrated marketing and sales toolbox for your store.'
        }
      ],
      storedata3:[
        {
          name:'The trendiest store with the best selling clothing',
          img:'/static/imgs/store9.png',
          link:'https://xixibrain1.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzR4TG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMDhUMDk6NDY6MDMuMTA4WiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--d306a0ad5d3a922b3d64ccc6612eb6bf195d4554&key=b376410269d447835849c3bd03c89e6952d560b8aed487bbd2cdf4fe5ed2df65'
        },
        {
          name:'Amazing store with home improvement tools',
          img:'/static/imgs/store10.png',
          link:'https://xixibrain2.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzR5TG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMDhUMDk6NDQ6NTguMzc4WiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--14079a460e5062b45854fcdc23160dafb69cac1c&key=05598d607373a5df8062102f58cf1f31e19fe18f4bfabbb8b0a19df194dabf70'
        },
        {
          name:'Have a variety of cute pet supplies and accessories',
          img:'/static/imgs/store11.png',
          link:'https://xixibrain3.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzR6TG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMDhUMDk6NDQ6MDMuMTMxWiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--5310ebf483d8caed907e3028db831644bbf0a20c&key=b8b60960bea4aa66345a455748eddd0f8ef109b58c64334f66aa67afc6770ad6'
        },
         {
          name:'Pretty family store with everything you need',
          img:'/static/imgs/store12.png',
          link:'https://xixibrain4.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzQwTG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMTNUMDI6NDU6MTQuNjc2WiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--b7ad1dde8a6ffd6678f92085e4323711559e99d4&key=85fde7828c789c670151ecf5ea119b90049b2d1bc257cad69155f9d5ebb08da4'
        },
        {
          name:'Rich store with wonderful gaming equipment and digital products',
          img:'/static/imgs/store13.png',
          link:'https://xixibrain5.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzQxTG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMTZUMTA6Mzc6MDQuNTkxWiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--77a6037639344b7ecc56fb746e592a7cd9ac7082&key=f88bd3c73a5f5b75d75765ea6da0172e1f1e00744910486038b8902c22093f07'
        },
        {
          name:'Top store with sports & outdoors supplies',
          img:'/static/imgs/store14.png',
          link:'https://xixibrain6.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzQyTG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMTZUMDQ6NDg6MTQuNTkzWiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--5c9e57b35a40c119c462cd3dbe35e846b123aacb&key=ec356c0b1b15cb5883800ec675163bdbb1554ccbd1432eac6e947993958695f4'
        },
         {
          name:'All kinds of holiday accessories and atmosphere decorations',
          img:'/static/imgs/store15.png',
          link:'https://xixibrain8.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzQ0TG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjItMDEtMDRUMDI6NDQ6NDAuNTcyWiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--e711eea69f700206e1fd0c6a0b7a9fa5e519c223&key=299d81089cfaaf8a74d33a9aa6d9804cd3b9c3de061f893a79daf068b38c0697'
        },
        {
          name:'The cutest store selling cute baby and mother products',
          img:'/static/imgs/store16.png',
          link:'https://xixibrain9.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDE0YVhocFluSmhhVzQ1TG0xNWMyaHZjR2xtZVM1amIyMEdPZ1pGVkE9PSIsImV4cCI6IjIwMjEtMTItMjlUMTE6MDQ6NTIuMzI4WiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--b91d32c437c5c1b0815f16c6f380966194c2ab9f&key=6fad698f5618c57c549ea4359cdfb5916728fcbb925977876d5170462a75c53e'
  
        },
        {
          name:'Have a variety of styles of diamond jewelry and watches',
          img:'/static/imgs/store17.png',
          link:'https://xixibrain7.myshopify.com/?_bt=eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaEpJaDU0YVhocFluSmhhVzR5TXk1dGVYTm9iM0JwWm5rdVkyOXRCam9HUlZRPSIsImV4cCI6IjIwMjItMDEtMTBUMDk6MzM6NTguNDY5WiIsInB1ciI6InBlcm1hbmVudF9wYXNzd29yZF9ieXBhc3MifX0%3D--e5c4845d68036a11d91e10ff2f48c843a63a9ea3'

        },
        {
          name:'A complete range of auto parts and maintenance equipment for sale',
          img:'/static/imgs/store18.png',
          link:'https://xixibrain23.myshopify.com/'
        }
      ],
      storedata4:[
        {
          name:'Your business starts super fast',
          content:'Building a quality dropshipping store on your own takes time and effort. But when you have a well-decorated dropshipping store, you can start making money right away, no waiting and no wasting time!'
        },
        {
          name:'You avoid risk and guesswork',
          content:'Choosing the right niche often requires research and testing. But our dropshipping stores have proven their success with high order volumes and expertly positioned niches. All you need to do is choose what you like.'
        },
        {
          name:'High cost performance',
          content:"Start your dropshipping store on Shopify, the world's best website building platform. The stability of its platform is time-tested. We'll build a solution for your store, including one year of free use of ANTDIY and ANTOOLS."
        }
      ],
      storedata5:[
        {
          name:'Deep ',
          name2:'niche research',
          img:'/static/imgs/store22.svg',
        },
        {
          name:'In-demand ',
          name2:'products',
          img:'/static/imgs/store23.svg',
        },
        {
          name:'Perfectly ',
          name2:'optimized themes',
          img:'/static/imgs/store24.svg',
        },
         {
          name:'Stylish ',
          name2:'design',
          img:'/static/imgs/store25.svg',
        },
        {
          name:'Mobile ',
          name2:'website',
          name3:'friendly ',
          img:'/static/imgs/store26.svg',
        },
        {
          name:'Premium ',
          name2:'domain name',
          img:'/static/imgs/store27.svg',

        },
         {
          name:'100% ',
          name2:'ownership',
          img:'/static/imgs/store28.svg',
        },
        {
          name:'Integrated ',
          name2:'marketing tools',
          img:'/static/imgs/store29.svg',
  
        },
        {
          name:'Automated ',
          name2:'management system',
          img:'/static/imgs/store30.svg',

        },
        {
          name:'Promo ',
          name2:'video',
          img:'/static/imgs/store31.svg',
        },
        {
          name:'On-site ',
          name2:'SEO',
          img:'/static/imgs/store32.svg',
        },
        {
          name:'Branded ',
          name2:'social pages',
          img:'/static/imgs/store33.svg',
        }
      ],
      tabledata:[
        {
          name:'Niche research',
          bubble:"We select a trendy, hign-demand niche for you after analyzing it for stable long-term positions and a great potential in future"
        },
        {
          name:'Custom design',
          bubble:"We create a unique and clean design for your website including a custom logo, header images, icons, favicon, banners, etc"
        },
        {
          name:'Mobile devices ready',
          bubble:"Your website will have a perfect responsive design fitting the screen size of any device, whether desktop or mobile"
        },
        {
          name:'Number of products ready to sell',
          bubble:"The number of products added to your website on development stage. Later you can upload unlimited number of products by yourself.",
          content:'50',
          content2:'100',
          content3:'200',
        },
        {
          name:'Payment gateways',
          bubble:"Our plugins support the most popular payment processors",
          content:'PayPal, Credit cards',
          content2:'PayPal, Credit cards',
          content3:'PayPal, Credit cards',
        },
        {
          name:'Delivery time',
          bubble:"We need several business days to provide a full-fledge dropshipping business: 10 to 23 days depending on your package",
          content:'10-13 business days',
          content2:'13-18 business days',
          content3:'18-23 business days',
        },
      ],
      tabledata2:[
        {
          name:'On-site SEO',
          content:'Meta data, Google indexing, social bookmarking',
          content2:'Meta data, Google indexing, social bookmarking',
          content3:'Meta data, Google indexing, social bookmarking, home page SEO article',
          bubble:"Our SEO services are designed to increase visibility within the organic search results and to deliver targeted traffic to your site",
        },
        {
          name:'Social pages',
          content:'Facebook',
          content2:'Facebook, Twitter, Instagram',
          content3:'Facebook, Twitter, Instagram, YouTube',
          bubble:"We will create and add design to the accounts of your business on top social networks and integrate social buttons and widgets on your website",
        },
        {
          name:'Promo video',
          content:'一',
          content2:'一',
          bubble:"Video will help you promote your webstore and tell your customers about all the advantages of your products and services",
        },
      ],
      tabledata3:[
        {
          name:'Custom Dropshipping package',
          bubble:"Only best selling and already edited products will be added to your store on the development stage.",
        },
        {
          name:'ANTDIY (Personal Edition)',
          content:'Basic',
          content2:'$238.80/yr',
          content3:'Standard',
          content4:'$838.80/yr',
          content5:'Advanced',
          content6:'$1558.80/yr',
          bubble:"ANTDIY is the dropshipping application of AliExpress official partners.",
        },
        {
          name:'ANTOOLS',
          content2:'$238.80/yr',
          content4:'$238.80/yr',
          content6:'$238.80/yr',
          bubble:"ANTOOLS is an All-in-One Marketing & Sales app for Shopify with 20+ sales-boosting plugins and advanced marketing capabilities organized in one panel.",
        },   
      ],
      sayList: [
        {
          icon: '/static/imgs/store34.svg',
          name: 'Peter brown',
          content: 'The team is very professional and patient. The whole project was completed in less time than promised and I am very proud of the venue they gave me. I highly recommend this service and WILL definitely use them again'
        },
        {
          icon: '/static/imgs/store35.svg',
          name: 'Olivia Caden',
          content: 'I like the decoration in my shop very much, the quality is good and there are many kinds of templates for you to choose from. Thanks to my project manager, always highly recommended.'
        },
        {
          icon: '/static/imgs/store36.svg',
          name: 'Ava Jackson',
          content: `My shop is beautifully decorated and very easy to use. The whole team is very professional. There are also many store promotions. The product variety is also very comprehensive`
        },
      ],
      ispc:'',
      showbubble:20,
      check:'',
      check2:'',
      check3:''
    }
  },
  methods:{
    golink(val){
      let winref=window.open("url","_blank")
      winref.location=val
    },
    freshchat(index){
      if (window.fcWidget.isLoaded()) {
        if(index===1){
          if(this.check==1){
            window.fcWidget.open({ replyText: 'Hi, I want to learn more about "Create a $299(Basic) store and add hosting"'})
          }else{
            window.fcWidget.open({ replyText: 'Hi, I want to learn more about "Create a $299(Basic) store"'})
          }     
        }else if(index===2){
          if(this.check2==2){
            window.fcWidget.open({ replyText: 'Hi, I want to learn more about "Create a $499(Advanced) store and add hosting"'})
          }else{
            window.fcWidget.open({ replyText: 'Hi, I want to learn more about "Create a $499(Advanced) store"'})
          }     
        }else{
          if(this.check3==3){
            window.fcWidget.open({ replyText: 'Hi, I want to learn more about "Create a $899(Ultimate) store and add hosting"'})
          }else{
            window.fcWidget.open({ replyText: 'Hi, I want to learn more about "Create a $899(Ultimate) store"'})
          }     
        }
      } 
    },
    scroll(){
      console.log(111)
      let end
      let front=document.querySelector('.header').offsetHeight
      end = document.querySelector('.store_back3').getBoundingClientRect().top-front
      let start = document.documentElement.scrollTop || document.body.scrollTop;
      let step = (end)/220;
      let d = step
      let count = 0;
      let timer =  setInterval(() => {
        if (count > 30 && count <= 70) {
          d = 3*step
        } else if (count > 10 && count <= 90) {
          d = 2*step
        } else if (count > 0 && count < 100) {
          d = step
        }
        start += d
        window.scrollTo(0, start)
        count++;
        if (count >= 100) {
          clearInterval(timer)
        }
      }, 10);    
    },
    bubble(index){
      console.log(index)
      this.showbubble=index
    },
    bubbleout(index){
      this.showbubble=20
    },
    add(val,index){
      if(val.target.checked==true){
        if(index==1){
          this.check=1
        }else if(index==2){
          this.check2=2
        }else if(index==3){
          this.check3=3
        }
      }else{
        if(index==1){
          this.check=''
        }else if(index==2){
          this.check2=''
        }else if(index==3){
          this.check3=''
        }
      }
    }
  },
  created(){
    if(document.body.offsetWidth>767){
      this.ispc=true
    }else{
      this.ispc=false
    }
  }
}
</script>

<style scoped>
.bubble_box{
  width:172px ;
  padding: 5px 10px;
  background: rgba(0,0,0,0.75);
  box-shadow: 0px 3px 6px -4px rgba(0,0,0,0.12);box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.08);box-shadow: 0px 9px 28px 8px rgba(0,0,0,0.05);
  border-radius: 4px;
  font-family: Helvetica;
  font-size: 12px;
  color: #FFFFFF;
  text-align: center;
  font-weight: 400;
  position: absolute!important;
  left: 50%;
  bottom: 30px;
  transform: translate(-50%);
}
.bubble_bottom{
  position: absolute!important;
  width: 0;
  height: 0;
  border-top: 10px solid rgba(0,0,0,.75);
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}
.store_back{
  width: 100%;
}
.store_back2{
  width: 100%;
  background: #F6F7FA;
}
.store_back3{
  width: 100%;
  background: rgba(252,83,34,.25);
}
.store_box{
  width: 1200px;
  margin:0 auto;
  padding: 70px 0 80px 0;
}
.store_box2{
  padding: 90px 0 80px 0;
}
.store_box3{
  padding: 90px 0 100px 0;
}
.store_box4{
  padding: 90px 0 60px 0;
}
.store_display{
  padding: 90px 0 100px 0;
}
.store_display h1{
  margin-bottom: 80px;
}
.store_box h1{
  font-family: Helvetica-Bold;
  font-size: 32px;
  color: #222536;
  text-align: center;
  line-height: 40px;
  font-weight: 700;
}
.store_box1 h1{
  width: 670px;
  margin: 0 auto;
}
.store_box3 h2{
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  font-weight: 400;
  margin: 30px auto 70px;
  text-align: center;
}
.store_box3 h1:first-child{
  color: #FC5322;
}
.store_box4 h1:first-child{
  color: #FC5322;
}
.store_box2 h1{
  margin-bottom: 50px;
}
.store_box1 em{
  width: 74px;
  height: 6px;
  background: #FC5421;
  border-radius: 3px;
  margin: 24px auto 35px auto;
  display: block;
}
.store_box1 p{
  font-family: Helvetica;
  font-size: 22px;
  color: #222536;
  letter-spacing: 0;
  text-align: center;
  line-height: 34px;
  font-weight: 400;
  margin:0 auto 45px;
  width: 910px;
}
.store_box_button{
  width: 291px;
  height: 52px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: Helvetica-Bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 52px;
  font-weight: 700;
  text-align: center;
  margin:0 auto;
  cursor: pointer;
}
.store_box2_content{
  display: flex;
  justify-content: space-between;
}
.store_box2_content2{
  flex-wrap: wrap;
}
.store_box2_content3{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 80px;
}
.store_box2_center{
  width: 350px;
}
.store_box2_center img{
  width: 350px;
  height: 255px;
}
.store_box2_center h2{
  font-family: Helvetica-Bold;
  font-size: 20px;
  color: #222536;
  text-align: justify;
  line-height: 28px;
  font-weight: 700;
  margin: 26px 0 12px 0;
}
.store_box2_center div{
  font-family: Helvetica;
  font-size: 16px;
  color: #8D919B;
  text-align: justify;
  line-height: 24px;
  font-weight: 400;
}
.store_overflow img{
  width: 1200px;
}
.store_works_line{
  width: 100%;
  margin-bottom: 33px;
}
.store_works{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.store_works img{
  width: 76px;
  height: 71px;
}
.store_works h2{
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: #222536;
  line-height: 28px;
  font-weight: 700;
  margin: 30px 0 13px 0;
}
.store_works div{
  font-family: Helvetica-Bold;
  font-size: 18px;
  color: #222536;
  text-align: center;
  line-height: 28px;
  font-weight: 700;
}
.store_type:nth-child(9){
  margin-bottom: 0;
}
.store_type:nth-child(10){
  margin-bottom: 0;
}
.store_type{
  width: 568px;
  box-shadow: 0 2px 14px 0 rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 50px;
  background-color: #FFFFFF;
  margin-bottom: 60px;
  border-radius: 20px;
}
.store_type h2{
  font-family: Helvetica-Bold;
  font-size: 28px;
  color: #222536;
  line-height: 40px;
  font-weight: 700;
  width: 502px;
  margin-top: 20px;
}
.store_type_img{
  width: 100%;
}
.store_type_view{
  display: flex;
  align-items: center;
  margin: 27px auto 25px;
  cursor: pointer;
}
.store_type_view span{
  font-family: Helvetica;
  font-size: 16px;
  color: #3282C9;
  font-weight: 400;
  margin-left: 10px;
}
.store_type_view img{
  width: 14px;
  height:14px;
}
.store_type_button{
  width: 370px;
  height: 52px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: Helvetica-Bold;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 52px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
}
.store_reason h2{
  font-family: Helvetica-Bold;
  font-size: 20px;
  color: #222536;
  text-align: justify;
  line-height: 28px;
  font-weight: 700;
}
.store_reason em{
  display: block;
  width: 46px;
  height: 4px;
  background: #FC5421;
  border-radius: 3px;
  margin: 16px 0 34px;
}
.store_reason div{
  font-family: Helvetica;
  font-size: 16px;
  color: #8D919B;
  text-align: justify;
  line-height: 24px;
  font-weight: 400;
  width: 350px;
}
.storetable{
  width: 100%;
  border: 1px solid rgba(215,221,239,1);
}
thead{
  background: #FF7148;
}
thead td{
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: #FFFFFF;
  font-weight: 700;
}
.storetable th:first-of-type {
  width: 389px;
}
.storetable td:first-of-type {
  width: 389px;
  padding:0 20px;
}
td,th{
  width: 269px;
  border: 1px solid rgba(215,221,239,1);
}
th{
  font-family: Helvetica-Bold;
  font-size: 24px;
  color: #FFFFFF;
  letter-spacing: 0;
  font-weight: 700;
  height: 80px;
}
td{
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  letter-spacing: 0;
  font-weight: 400;
}
.tablebody_first{
  height: 167px;
  background-color: #FFFFFF;
}
.tablebody_first_p{
  font-size: 20px;
  font-weight: 700;
}
.tablebody_first_td{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tablebody_first_td p{
  font-size: 40px;
  color: #222536;
  letter-spacing: 2.22px;
  font-weight: 700;
}
.tablebody_first_td div{
  padding: 0 20px;
  text-align: center;
  margin-top: 10px;
}
input{
  margin-right: 15px;
}
.tablebody_second{
  height: 98px;
}
.tablebody_second div{
  width: 200px;
  height: 48px;
  background: #FC5322;
  box-shadow: 0px 6px 8px 0px rgba(252,83,34,0.1);
  border-radius: 4px;
  font-family: Helvetica-Bold;
  font-size: 16px;
  color: #FFFFFF;
  font-weight: 700;
  line-height: 48px;
  text-align: center;
  cursor: pointer;
  margin: 0 auto;
}
.tablebody_head{
  height: 58px;
  background-color: #FFFFFF;
}
.tablebody_head td{
  border: none;
}
.tablebody_content{
  height: 58px;
}
.tablebody_content2{
  height: 111px;
}
.tablebody_content3{
  height: 88px;
}
.tablebody_content_first{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tablebody_content_first img{
  width: 14px;
  height: 14px;
}
.tablebody_content_first div{
  position: relative;
}
.tablebody_content_main{
  text-align: center;
  padding: .1rem;
}
.tablebody_content_main_center{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tablebody_content_main_center h3{
  font-family: Helvetica;
  font-size: 16px;
  color: #EE0808;
  line-height: 19px;
  font-weight: 400;
  margin-top: 15px;
}
.tablebody_content_main_center div{
  font-family: Helvetica;
  font-size: 16px;
  color: #A9ABB6;
  line-height: 19px;
  font-weight: 400;
}
.store_need{
  width: 280px;
  height: 276px;
  background: #F6F7FA;
  box-shadow: 0px 5px 4px 0px rgba(167,167,167,0.06);
  border-radius: 20px;
  padding: 55px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}
.store_need img{
  width: 108px;
  height: 108px;
  margin-bottom: 30px;
}
.store_need div{
  font-family: Helvetica;
  font-size: 18px;
  color: #222536;
  line-height: 28px;
  font-weight: 400;
  text-align: center;
}
.store_need_bold{
  font-family: Helvetica-Bold;
  font-weight: 700;
}
@media(max-width:767px){
  .top {
    background-image: none !important;
  }
  .top_box{
    width: 100%;
    height: auto;
    padding: .96rem .48rem .8rem;
    flex-direction: column;
  }
  .top_left{
    width: 100%;
    padding: 0;
  }
  .top_left_symbol{
    margin: .72rem 0 .4rem;
  }
  .ad_button{
    width: 100%;
    height: .96rem;
    box-shadow: 0 .09rem .12rem 0 rgba(252,83,34,0.1);
    border-radius: .08rem;
    font-weight: 700
  }
  .title_icon{
    width: .36rem;
    height: .06rem;
    border-radius: .03rem;
  }
  .top_left_title{
    font-size: .44rem;
    letter-spacing: 0;
    line-height: .6rem;
  }
  .top_left_subtitle{
    margin: .23rem 0 .63rem;
    font-size: .28rem;
    letter-spacing: 0;
    line-height: .44rem;
    width: 100%;
  }
  .ad_button{
    width: 100%;
    text-align: center;
    border-radius: .08rem;
    font-size: .28rem;
    letter-spacing: .014rem;
  }
  .bubble_box{
    width:2.72rem ;
    padding: .12rem .1rem;
    box-shadow: 0px .09rem .28rem .08rem rgba(0,0,0,0.05);
    border-radius: .04rem;
    font-size: .24rem;
    left: 50%;
    bottom: .3rem;
    transform: translate(-50%);
  }
  .bubble_bottom{
    border-top: .1rem solid rgba(0,0,0,.75);
    border-left: .06rem solid transparent;
    border-right: .06rem solid transparent;
    bottom: -.1rem;
    left: 50%;
    transform: translateX(-50%);
  }
  .store_box_button{
    width: 100%;
    height: .96rem;
    background: #FC5322;
    box-shadow: 0px .09rem .12rem 0px rgba(252,83,34,0.1);
    border-radius: .08rem;
    font-size: .28rem;
    color: #FFFFFF;
    line-height: .96rem;
  }
  .store_box{
    width: 100%;
    padding: .65rem .48rem .8rem;
  }
  .store_box2,.store_box3,.store_box4,.store_display{
   padding: .65rem .48rem .8rem;
  }
  .store_display h1{
    width: 3.72rem;
    margin: 0 auto .7rem;
  }
  .store_box h1{
    font-size: .48rem;
    line-height: .6rem;
  }
  .store_box3 h2{
    font-size: .24rem;
    margin: .25rem auto .7rem;
  }
  .store_box2 h1{
    margin-bottom: .7rem;
  }
  .store_box2_content{
    display: initial;
  }
  .store_box2_content3{
    margin-top: .7rem;
  }
  .store_box2_center{
    width: 100%;
  }
  .store_box2_center img{
    width: 100%;
    height: auto;
  }
  .store_box2_center h2{
    font-size: .3rem;
    margin: .6rem 0 .35rem 0;
  }
  .store_box2_center div{
    font-size: .24rem;
    line-height:.36rem;
  }
  .store_box2_center + .store_box2_center{
    margin-top: .5rem;
  }
  .store_overflow{
    overflow: auto;
  }
  .store_works_line{
    width: 100%;
    margin-bottom: 33px;
  }
  .store_works{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .store_works img{
    width: 76px;
    height: 71px;
  }
  .store_works h2{
    font-family: Helvetica-Bold;
    font-size: 24px;
    color: #222536;
    line-height: 28px;
    font-weight: 700;
    margin: 30px 0 13px 0;
  }
  .store_works div{
    font-family: Helvetica-Bold;
    font-size: 18px;
    color: #222536;
    text-align: center;
    line-height: 28px;
    font-weight: 700;
  }
  .store_type:nth-child(9){
    margin-bottom: .3rem;
  }
  .store_type:nth-child(10){
    margin-bottom: 0;
  }
  .store_type{
    width: 100%;
    box-shadow: 0 .02rem .14rem 0 rgba(0,0,0,0.06);
    padding-bottom: .5rem;
    margin-bottom: .3rem;
    border-radius: .2rem;
  }
  .store_type h2{
    font-size: .32rem;
    line-height: .4rem;
    width: 6rem;
    margin-top: .4rem;
  }
  .store_type_view{
    margin: .45rem auto .25rem;
  }
  .store_type_view span{
    font-size: .2rem;
    margin-left: .08rem;
  }
  .store_type_view img{
    width: .16rem;
    height:.16rem;
  }
  .store_type_button{
    width: 4.26rem;
    height: .6rem;
    box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
    border-radius: .04rem;
    font-size: .22rem;
    line-height: .6rem;
  }
  .store_reason+.store_reason{
    margin-top: .45rem;
  }
  .store_reason h2{
    font-size: .3rem;
    line-height: .28rem;
  }
  .store_reason em{
    width: .45rem;
    height: .06rem;
    border-radius: .03rem;
    margin: .3rem 0 .25rem;
  }
  .store_reason div{
    font-size: .24rem;
    line-height: .36rem;
    width: auto;
  }
  .storetable{
    width: 100%;
    border: 1px solid rgba(215,221,239,1);
    overflow: auto;
  }
  .overflow{
     overflow-x: auto;
     width: 100%;
  }
  thead tr{
     height: .8rem;
  }
  thead td{
    font-size: .24rem;
  }
  label{
    display: flex;
    justify-content:center;
    font-size:.18rem;
    text-align: left;
  }
  .storetable th:first-of-type {
    width: 3.89rem;
  }
  .storetable td:first-of-type {
    width: 3.89rem;
    padding:0 .2rem;
  }
  td,th{
    width: 2.69rem;
  }
  th{
    font-size: .24rem;
    height: .8rem;
  }
  td{
    font-size: .18rem;
  }
  .tablebody_first{
    height: 1.67rem;
  }
  .tablebody_first_p{
    font-size: .2rem;
  }
  .tablebody_first_td p{
    font-size: .4rem;
    letter-spacing: .0222rem;
  }
  .tablebody_first_td div{
    padding: 0 .2rem 0 .4rem;
    margin-top: .1rem;
  }
  input{
    margin-right: .15rem;
  }
  .tablebody_second{
    height: .98rem;
  }
  .tablebody_second div{
    width: 2rem;
    height: .48rem;
    box-shadow: 0px .06rem .08rem 0px rgba(252,83,34,0.1);
    border-radius: .04rem;
    font-size: .16rem;
    line-height: .48rem;
  }
  .tablebody_head{
    height: .58rem;
  }
  .tablebody_content{
    height: .58rem;
  }
  .tablebody_content2{
    height: 1.11rem;
  }
  .tablebody_content3{
    height: .88rem;
  }
  .tablebody_content_main_center h3{
    font-size: .16rem;
    line-height: .19rem;
    margin-top: .15rem;
  }
  .tablebody_content_main_center div{
    font-size: .16rem;
    line-height: .3rem;
  }
  .tablebody_content_first img{
    width: .2rem;
    height: .2rem;
  }
  .tablebody_content_main img{
    width: .18rem;
    height: .18rem;
  }
  .store_need{
    width: 3rem;
    height: auto;
    box-shadow: 0px .02rem .1rem 0px rgba(167,167,167,0.06);
    border-radius: .2rem;
    padding: .57rem .2rem;
    margin-bottom: .3rem;
  }
  .store_need img{
    width: 1.08rem;
    height: 1.08rem;
    margin-bottom: .25rem;
  }
  .store_need div{
    font-size: .22rem;
    line-height: .28rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/getstore.vue